import { render, staticRenderFns } from "./CustomizeModal.vue?vue&type=template&id=18758dbc&"
import script from "./CustomizeModal.vue?vue&type=script&lang=js&"
export * from "./CustomizeModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeModal.vue?vue&type=style&index=0&id=18758dbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports